function listingsAccordion() {
	const listings = document.querySelectorAll('.listing-card');
	const feedbackForm = document.getElementById('feedback-form');
	const feedbackFormClose = document.querySelectorAll(
		'.feedback-form__close'
	);
	const serviceNameField = feedbackForm
		.querySelector('.service-name-input')
		.getElementsByTagName('input')[0];
	if (listings) {
		listings.forEach(function (el) {
			const listingToggle = el.querySelector('.listing-card__toggle');

			listingToggle.addEventListener('click', function () {
				el.classList.toggle('is-open');
			});

			const feedbackToggle = el.querySelector('.feedback-trigger');
			const listingTitle = el.querySelector('.listing-title').textContent;

			feedbackToggle.addEventListener('click', function (a) {
				console.log(listingTitle);
				console.log(serviceNameField);
				serviceNameField.value = listingTitle;
				a.preventDefault();
				this.classList.toggle('is-open');
				feedbackForm.classList.add('is-open');
			});
			feedbackFormClose.forEach(function (el) {
				el.addEventListener('click', function () {
					feedbackForm.classList.remove('is-open');
				});
			});
		});
	}
}

listingsAccordion();
